import { DriverType } from './DriverInfo/DriverInfo';
import { loadComponentInSourcelessIframeInternal } from './Iframe-sourceless/Outside/loadComponentInSourcelessIframeInternal';
/**
 * Creates a detached container from code and loads its default component the same way loadComponentInSourcelessIframe does
 */
export function createComponentFromCodeInSourcelessIframe(props) {
    return createOrRehydrateHelper(props, props.options, {
        type: 'CreateFromCode',
        driverType: props.config?.driverImplementationOverride ? DriverType.Custom : DriverType.SPO,
        codeDetails: props.codeDetails,
        loadTemplateProps: props.loadTemplateProps
    }, Date.now() /* bootstrapperStartTime */);
}
/**
 * Rehydrates a detached container from snapshot
 */
export function rehydrateComponentFromSnapshotInSourcelessIframe(props) {
    return createOrRehydrateHelper(props, props.options, {
        type: 'RehydrateFromSnapshot',
        driverType: props.config?.driverImplementationOverride ? DriverType.Custom : DriverType.SPO,
        snapshot: props.snapshot
    }, Date.now() /* bootstrapperStartTime */);
}
function createOrRehydrateHelper(props, options, initializeConfig, bootstrapperStartTime) {
    const { dependencySynthesizer, hostContext, config, iframeHostingElement } = props;
    return loadComponentInSourcelessIframeInternal({
        initializeConfig,
        iframeHostingElement,
        dependencySynthesizer,
        hostContext,
        config: config ?? {},
        options,
        additionalInfo: { bootstrapperStartTime }
    });
}
// cspell:ignore Rehydrates bootstrapper
//# sourceMappingURL=createComponentInSourcelessIframe.js.map